import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type RfqLineDeleteParams = {
  uuid: string
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const useRfqLineDeleteMutation = () =>
  useMutation<any, ErrorDTO, RfqLineDeleteParams>({
    mutationFn: async (params) => {
      try {
        const res = await client.delete(`/rfq/line/delete/${params.uuid}`)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
